import React from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../../../assets/icons/red-warning.svg";
import "../ConfirmDeleteCategoryModal/ConfirmDeleteCategoryModal.less";

export type ConfirmDeleteScriptModalProps = {
  name: string;
  onConfirm: (name: string) => void;
  onCancel: () => void;
};

const ConfirmDeleteScriptModal: React.FC<ConfirmDeleteScriptModalProps> = ({ name, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onCancel?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="confirm-delete-category-overlay" onClick={handleOverlayClick}>
      <div className="confirm-delete-category-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="confirm-delete-category-container">
          <img src={RedWarningIcon} className="confirm-delete-category-icon" alt="Warning" />
          <div className="confirm-delete-category-title">{t("delete-script-confirm-title")}</div>
          <div className="confirm-delete-category-desc">{t("delete-script-confirm-desc")}</div>
          <button type="button" className="confirm-delete-button" onClick={() => onConfirm(name)}>
            {t("confirm")}
          </button>
          <button type="button" className="confirm-cancel-button" onClick={onCancel}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteScriptModal;
